<app-rback [rsback]='true'></app-rback>

<app-xtheme theme='red'>
  <app-xtheme-hh>
    <div class="header-wrapper">
      <div class="search">
        <div class="logo2name red-theme-color">{{ttitle}}</div>

        <div class="full-map-group" (click)="toView()">
          <img class="fullmap-btn" src="/assets/imgs/new/imap.png"/>
          <div class="txt red-theme-color">地图模式</div>
        </div>
        <img class="compass" src="/assets/imgs/icon/compass.png" />
      </div>
    </div>
    <div class="map-group" (click)="toView()">  
      <div class="map-zoom">
        <app-hzoom>
          <img src="/assets/imgs/new/redgif/7-{{seli}}.gif"/>
        </app-hzoom>
      </div> 
    </div>
 
    <div class="result-wrapper">
      <app-liked-shared [mapkey]="'redcityculture'"></app-liked-shared>
      <div class="list-group red-list-bg">
        <div class="lwtitle title-lab red-list-border-bottom">
          <div class="tl red-list-border-left" *ngFor="let item of profs;let i=index" [ngClass]="{'red-theme-color': seli===i}" (click)="changeIType(i)">{{item}}</div>
        </div>
        <div class="lwtitle red-theme-color red-list-border-bottom">
          <div class="pre iicon" (click)="preProf()">
            <img class="ipre" src="/assets/imgs/new/i-arrow-y.png"/>
          </div>
          <div class="title">{{areas[seli][seli2]}}</div>
          <div class="next iicon" (click)="nextProf()"> 
            <img class="ipre" src="/assets/imgs/new/i-arrow-y.png"/>
          </div>
        </div>

        <div class="llitem " style="width: 1px;height: 0.1px;overflow: hidden;" *ngFor="let item of rows" >{{item.id}}</div> 
        <div class="llitem " style="width: 1px;height: 0.1px;overflow: hidden;" *ngFor="let item of rows" >{{item.name}}</div> 
        <div class="lwtlist">
          <div class="llitem " *ngFor="let item of rows; let i = index;" (click)="toView(item.id)">{{i + 1}}. {{item.name}}</div>
          <div class="llitem" *ngIf="rows.length===0">无数据</div>
        </div> 
      </div>
    </div>
    <div class="copytime-group">
      <div class="copytime">资料来源：2020版上海红色文化地图</div>
      <div class="copytime">资料截至日期：2020年10月</div>
    </div>
    
  </app-xtheme-hh>
  <app-xtheme-vv>

    <div class="left-lw"> 
 
      <div class="full-map-group" (click)="toView()">
        <img class="fullmap-btn" src="/assets/imgs/new/imap.png" />
        <div class="txt red-theme-color">地图模式</div>
      </div>
      <img class="compass" src="/assets/imgs/icon/compass.png" />

      <div class="map-group" (click)="toView()">  
        <div class="map-zoom">
          <app-zoomer>
            <img src="/assets/imgs/new/redgif/7-{{seli}}.gif"/>
          </app-zoomer>
        </div> 
      </div>
    </div>
    <div class="right-lw">
  
      <div class="header-wrapper"> 
       
        <div class="search"> 
          <div class="logoname2 red-theme-color">{{ttitle}}</div>
        </div>
      </div>
     
      <div class="result-wrapper">
        <div class="list-group red-list-bg">
          <div class="lwtitle title-lab red-list-border-bottom">
            <div class="tl red-list-border-left" *ngFor="let item of profs;let i=index" [ngClass]="{'red-theme-color': seli===i}" (click)="changeIType(i)">{{item}}</div>
          </div>
          <div class="lwtitle red-theme-color red-list-border-bottom">
            <div class="pre iicon" (click)="preProf()">
              <img class="ipre" src="/assets/imgs/new/i-arrow-y.png"/>
            </div>
            <div class="title">{{areas[seli][seli2]}}</div>
            <div class="next iicon" (click)="nextProf()"> 
              <img class="ipre" src="/assets/imgs/new/i-arrow-y.png"/>
            </div>
          </div>
          <div class="lwtlist">
            <div class="llitem " *ngFor="let item of rows; let i = index;" (click)="toView(item.id)">{{i + 1}}. {{item.name}}</div>
            <div class="llitem" *ngIf="rows.length===0">无数据</div>
          </div>
        </div>
      </div>

      <div class="copytime-group">
        <div class="copytime">资料来源：2020版上海红色文化地图</div>
        <div class="copytime">资料截至日期：2020年10月</div>
      </div>
      
    </div>
  
  </app-xtheme-vv>
</app-xtheme>
  